import { Button, Row, Spin } from "antd";
import Title from "antd/lib/typography/Title";
import React from "react";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import ModalComponent from "../formComponent/ModalComponent";

const ProductSaleReportModal = (props) => {
    const reportRef = useRef();
    const handleOnPrint = useReactToPrint({
        content: () => reportRef.current,
        pageStyle: `
        @media print {
          .main {
            page-break-inside: avoid;
          }
        }
        `,
    });

    const ProductSaleReport = React.forwardRef((props, ref) => {
        const { reportData, operationId } = props;

        const tableData = reportData?.Table1 || [];
        const productCategories = tableData.length
            ? [
                ...new Set(
                    tableData.map(
                        (item) => item?.Category || "Uncategorized"
                    )
                ),
            ]
            : [];

        return (
            <div
                ref={ref}
                style={{
                    backgroundColor: "white",
                    margin: "10px 5px",
                    fontWeight: "1000",
                    color: "#000",
                }}
                className="main"
            >
                <div style={{ border: "2px solid #000", textAlign: "center" }}>
                    <p style={{ marginTop: 0, color: "#000" }}>
                        {operationId === 6
                            ? "Business Day Product Sale Report"
                            : operationId === 7
                                ? "Shift Product Sale Report"
                                : operationId === 8
                                    ? "Terminal Product Sale Report"
                                    : ""}
                    </p>
                </div>

                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <p style={{ margin: "3px 0", textAlign: "center" }}>Branch</p>
                    <p style={{ margin: "3px 0", textAlign: "center" }}>
                        {reportData && reportData?.Table && reportData.Table[0]?.BranchName}
                    </p>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <p style={{ margin: "3px 0", textAlign: "center" }}>Business Day</p>
                    <p style={{ margin: "3px 0", textAlign: "center" }}>
                        {reportData &&
                            reportData?.Table &&
                            reportData.Table[0]?.BusinessDayName}
                    </p>
                </div>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <p style={{ margin: "3px 0", textAlign: "center" }}>Business Date</p>
                    <p style={{ margin: "3px 0", textAlign: "center" }}>
                        {reportData &&
                            reportData.Table &&
                            (
                                reportData.Table[0]?.BusinessDate?.includes("T")
                                    ? reportData.Table[0].BusinessDate.split("T")[0]
                                    : reportData.Table[0]?.BusinessDate
                            )
                        }
                    </p>
                </div>

                {operationId === 7 ? (
                    <>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <p style={{ margin: "3px 0", textAlign: "center" }}>Shift</p>
                            <p style={{ margin: "3px 0", textAlign: "center" }}>
                                {reportData &&
                                    reportData?.Table &&
                                    reportData.Table[0]?.ShiftName}
                            </p>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <p style={{ margin: "3px 0", textAlign: "center" }}>Shift Date</p>
                            <p style={{ margin: "3px 0", textAlign: "center" }}>

                                {reportData &&
                                    reportData.Table &&
                                    (
                                        reportData.Table[0]?.ShiftDate?.includes("T")
                                            ? reportData.Table[0].ShiftDate.split("T")[0]
                                            : reportData.Table[0]?.ShiftDate
                                    )
                                }
                            </p>
                        </div>
                    </>
                ) : (
                    ""
                )}
                {operationId === 8 ? (
                    <>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <p style={{ margin: "3px 0", textAlign: "center" }}>Shift</p>
                            <p style={{ margin: "3px 0", textAlign: "center" }}>
                                {reportData &&
                                    reportData?.Table &&
                                    reportData.Table[0]?.ShiftName}
                            </p>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <p style={{ margin: "3px 0", textAlign: "center" }}>Terminal</p>
                            <p style={{ margin: "3px 0", textAlign: "center" }}>
                                {reportData &&
                                    reportData?.Table &&
                                    reportData.Table[0]?.TerminalName}
                            </p>
                        </div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            <p style={{ margin: "3px 0", textAlign: "center" }}>
                                Terminal Date
                            </p>
                            <p style={{ margin: "3px 0", textAlign: "center" }}>
                                {reportData &&
                                    reportData.Table &&
                                    (
                                        reportData.Table[0]?.TerminalDate?.includes("T")
                                            ? reportData.Table[0].TerminalDate.split("T")[0]
                                            : reportData.Table[0]?.TerminalDate
                                    )
                                }
                            </p>
                        </div>
                    </>
                ) : (
                    ""
                )}

                <div style={{ border: "2px solid #000", textAlign: "center" }}>
                    <p style={{ marginTop: 0, color: "#000" }}>
                        <table style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th
                                        style={{
                                            fontWeight: "1000",
                                            color: "#000",
                                            textAlign: "left",
                                        }}
                                    >
                                        Product
                                    </th>
                                    <th
                                        style={{
                                            fontWeight: "1000",
                                            color: "#000",
                                            textAlign: "right",
                                        }}
                                    >
                                        Quantity
                                    </th>

                                    <th
                                        style={{
                                            fontWeight: "1000",
                                            color: "#000",
                                            textAlign: "right",
                                        }}
                                    >
                                        Amount
                                    </th>
                                </tr>
                            </thead>
                        </table>
                    </p>
                </div>

                {productCategories.length > 0 ? (
                    productCategories.map((category) => (
                        <div key={category} style={{ marginBottom: 16 }}>
                            <p
                                style={{
                                    borderBottom: "2px solid black",
                                    width: "100%",
                                    textAlign: "center",
                                    padding: 4,
                                    backgroundColor: "#f4f4f4",
                                }}
                            >
                                {category}
                            </p>
                            <table style={{ width: "100%" }}>

                                <tbody>
                                    {tableData
                                        .filter(
                                            (row) =>
                                                (row?.Category || "Uncategorized") ===
                                                category
                                        )
                                        .map((row, index) => (
                                            <tr key={`${category}-${index}`}>
                                                <td
                                                    style={{
                                                        fontWeight: "600",
                                                        color: "#000",
                                                    }}
                                                >
                                                    {row.Product}
                                                </td>
                                                <td
                                                    style={{
                                                        fontWeight: "600",
                                                        color: "#000",
                                                        textAlign: "right",
                                                    }}
                                                >
                                                    {row.Quantity}
                                                </td>
                                                <td
                                                    style={{
                                                        fontWeight: "600",
                                                        color: "#000",
                                                        textAlign: "right",
                                                    }}
                                                >
                                                    {0}
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    ))
                ) : (
                    <p style={{ textAlign: "center" }}>No product sale data</p>
                )}

                <hr style={{ height: 2, backgroundColor: "gray" }} />
            </div>
        );
    });

    return (
        <div>
            <ModalComponent
                title={
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                        }}
                    >
                        <Title level={5}>Product Sale Report</Title>
                        <div style={{ display: "flex" }}>
                            <Button
                                onClick={() => {
                                    props.setProductSaleModal(false);

                                }}
                                style={{ marginRight: 5 }}
                            >
                                Close
                            </Button>

                            <Button
                                onClick={() => {
                                    handleOnPrint();
                                }}
                                type="primary"
                            >
                                Print
                            </Button>
                        </div>
                    </div>
                }
                isModalVisible={props.productSaleModal}
                footer={[]}
            >
                <div align="center">
                    <Row style={{ placeContent: "center" }}>
                        <ProductSaleReport
                            ref={reportRef}
                            reportData={props.record}
                            operationId={props.operationId}
                        />
                    </Row>
                </div>
            </ModalComponent>
        </div>
    );
};

export default ProductSaleReportModal;